import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // FeedbackButton.js 的翻譯
      "feedback": "Feedback",
      "leaveFeedback": "Leave Your Feedback",
      "feedbackPlaceholder": "Please enter your feedback...",
      "feedbackSubmitted": "Feedback submitted, thank you!",
      "feedbackSubmitError": "Submission failed, please try again later.",
      "submit": "Submit",

      // WalletRisk.js 的翻譯
      "walletRiskAssessment": "Wallet Risk Assessment",
      "walletSearchDescription": "Search first, then quickly report suspicious wallet addresses",
      "report": "Submit Transaction Report",
      "inputWalletAddress": "Enter Wallet Address",
      "assessRisk": "Assess Risk",
      "mainEntity": "Main Entity",
      "nameTag": "Name Tag",
      "walletRiskDetails": "Wallet Risk Details",
      "sanctionCheckResult": "Sanction Check Result",
      "walletSanctioned": "This wallet is sanctioned.",
      "walletNotSanctioned": "This wallet is not sanctioned.",
      "noWalletTags": "No tags found for this wallet address.",
      "unknown": "Unknown",
      "search": "Search",
      "thisIsMyWallet": "This is my wallet",
      "thisIsSuspiciousWallet": "This is a suspicious wallet",
      "walletAddedToWhitelist": "Wallet address added to whitelist",
      "errorAddingWalletToWhitelist": "Error adding wallet address to whitelist",
      "walletAddedToBlacklist": "Wallet address added to blacklist",
      "errorAddingWalletToBlacklist": "Error adding wallet address to blacklist",
      "enterValidWalletAddress": "Please enter a valid wallet address",
      "enterComment": "Enter comment",
      "labelScam": "Scam",
      "labelPhishing": "Phishing",
      "labelMoneyLaundering": "Money Laundering",
      "labelFraud": "Fraud",
      "complianceRiskScore": "Compliance Risk Score",
      "riskScore": "Risk Score",
      "riskIndicators": "Risk Indicators",
      "indicatorName": "Name",
      "indicatorCode": "Code",
      "sanctionSource": "Sanction Source",

      
      // 首頁的翻譯
      "welcomeToApp": "DamenKYT",
      "appDescription": "A fraud prevention and cybersecurity platform designed for Web3 users, providing tools such as wallet risk query, AI risk prediction, and scam path analysis to help users identify and prevent fraudulent activities, enhancing the security of the Web3 ecosystem.",
      "guestReportInfo": "You have an unlinked report",
      "guestId": "Guest ID",
      "errorFetchingGuestReport": "Error fetching report information",
      // 導航列的翻譯
      "generateReport": "Report Your Case",
      "pathAnalysis": "Path Analysis",
      "walletRiskQuery": "Wallet Risk Query",
      "aiRiskPrediction": "AI Risk Prediction",
      "blockchainAcademy": "Blockchain Academy",
      "memberArea": "Member Area",
      "dashboard": "Dashboard",
      "memberInfo": "Member Information",
      "favorites": "My Favorites",
      "toggleMode": "Toggle Mode",
      "login": "Login",
      "logout": "Logout",
      "welcomeToDamenKYT": "Welcome to DamenKYT",
      "loginToAccessMore": "Log in to access more features such as member area, personal wallet address management, liking and favoriting blockchain academy articles",
      "loginWithGoogle": "Login with Google",

      // Footer 的英文
      "companyInfo": "Company Information",
      "kaohsiungOffice": "Kaohsiung Office",
      "kaohsiungAddress": "Ziqiang 3rd Rd., 29F-7, Lingya District, Kaohsiung City",
      "taipeiOffice": "Taipei Office",
      "taipeiAddress": "Minquan East Rd. Sec. 3, 12F, Zhongshan District, Taipei City",
      "contactPhone": "Phone",
      "contactEmail": "Email",
      "quickLinks": "Quick Links",
      "aboutUs": "About Us",
      "services": "Services",
      "reportSystem": "Report System",
      "contactUs": "Contact Us",
      "legalAndPolicy": "Legal & Policy",
      "privacyPolicy": "Privacy Policy",
      "termsOfService": "Terms of Service",
      "socialMedia": "Social Media",
      "allRightsReserved": "All Rights Reserved",
      "contactInfo": "Contact Us",
      "companyName": "Company Name",
      "taxID": "Unified Business Number",
      "customerEmail": "Customer Service Email",
      "companyWebsite": "Official Website",
      "donation": "Donation",
      "supportUs": "Support Us",
      "donationTransparency": "Donation Transparency",

      // Report 的翻譯
        // StepIndicator 的翻譯
        "caseDetails": "Case Details",
        "scammerInformation": "Scammer Information",
        "description": "Description and Evidence Upload",
        "contactSupport": "Contact and Confirm",
        // ScamQuiz 的翻譯
        "notSureWhatToChoose": "Not sure what to choose?",
        "takeQuizDescription": "Take our Scam Quiz to help you find out.",
        "takeScamQuiz": "Take Scam Type Quiz",
        "howDidItOccur": "How did the scam occur?",
        "specifyFraudType": "Specify the type of fraud",
        "blackmailedSendCrypto": "I was blackmailed to send crypto",
        "blackmailSextortion_description": "Threatened me to release compromising sexual information",
        "blackmailRansomware_description": "Blocked my system and asked payment to release it",
        "trickedTransferCrypto": "I was tricked to transfer crypto",
        "unauthorizedPayment": "Someone made a payment I never authorized",
        "specifyBlackmailType": "Specify the type of blackmail",
        "specifyHackType": "Specify the type of hack",
        "fraudNftAirdrop_description": "Scammer distributed fake NFTs to trick victims.",
        "fraudPhishing_description": "Scammer tricked victim into revealing sensitive information via a fake website or email.",
        "fraudImpersonation_description": "Scammer pretended to be someone else to deceive victims.",
        "fraudDonation_description": "Scammer impersonated a charity to solicit fake donations.",
        "fraudRomance_description": "Scammer formed a fake romantic relationship to scam money.",
        "fraudPigButchering_description": "Scammer tricked victims into investing in fake financial schemes.",
        "fraudFakeProject_description": "Scammer promoted a fake project to steal money from investors.",
        "fraudRugPull_description": "Scammer abruptly withdrew funds from a project, leaving investors with nothing.",
        "fraudFakeReturns_description": "Scammer promised high returns on investments but never delivered.",
        "hackSimSwap_description": "Scammer took control of my phone number to access my accounts.",
        "hackContractExploit_description":"I may have interacted with a smart contract that was exploited",
        "hackPasswordCrack_description": "Scammer cracked my password to access my accounts",
        "hackPrivateKeyLeak_description": "Scammer leaked my private key to access my accounts",
        "close": "Close",
        "yourIncidentTypeIs": "Your incident type is",


        // Step1 下拉選單
        "selectIncidentType": "Select Incident Type",
        "pleaseSelect": "Please Select",
        "blackmailSextortion": "Blackmail - Sextortion Scam",
        "blackmailRansomware": "Blackmail - Ransomware",
        "blackmailOther": "Blackmail - Other",
        "fraudNftAirdrop": "Fraud - NFT Airdrop Scam",
        "fraudPhishing": "Fraud - Phishing Scam",
        "fraudImpersonation": "Fraud - Impersonation Scam",
        "fraudDonation": "Fraud - Donation Impersonation Scam",
        "fraudRomance": "Fraud - Romance Scam",
        "fraudPigButchering": "Fraud - Pig Butchering Scam",
        "fraudFakeProject": "Fraud - Fake Project Investment Scam",
        "fraudRugPull": "Fraud - Rug Pull Investment Scam",
        "fraudFakeReturns": "Fraud - Fake Returns Investment Scam",
        "fraudOther": "Fraud - Other",
        "hackSimSwap": "Hack - SIM Swap",
        "hackContractExploit": "Hack - Contract Exploit",
        "hackPasswordCrack": "Hack - Password Crack",
        "hackPrivateKeyLeak": "Hack - Private Key Leak",
        "hackOther": "Hack - Other",
        "other": "Other",
        "pleaseSpecify": "Please specify",
        "pleaseSpecifyIncident": "Please specify the incident type",
        "reportSharing": "Report Sharing",
        "postReportOnDamenKYT": "Post report on DamenKYT",
        "publicReportInfo": "Most users choose to make their report public to alert the community. All personal information will remain private. DamenKYT will never share your personal details on the platform.",
        "submitReportPrivately": "Submit report privately",
        "pleaseSelectIncidentType": "Please select an incident type",
        "pleaseSelectReportType": "Please select a report sharing option",
        // Step2.js 的翻譯
        "scammerInfoDescription": "Please provide as much information as possible about the scammer.",
        "transactionDetails": "Transaction Details",
        "transactionDetailsDescription": "Enter the transaction details when funds were transferred from your wallet to the scammer's wallet. If there are multiple transactions, click the button below to add more transactions.",
        "victimWalletAddress": "Victim's Wallet Address (Required)",
        "enterVictimWalletAddress": "Enter victim's wallet address",
        "scammerWalletAddress": "Scammer's Wallet Address (Required)",
        "enterScammerWalletAddress": "Enter scammer's wallet address",
        "selectChain": "Select Blockchain",
        "dateOfFraud": "Date of Fraud",
        "amount": "Amount",
        "enterAmount": "Enter amount",
        "currency": "Currency",
        "enterCurrency": "Enter currency",
        "transactionID": "Transaction ID (Hash Value)",
        "uploadTransactionScreenshot": "Upload Transaction Screenshot",
        "enterTransactionID": "Enter transaction ID",
        "addTransactions": "Add More Transactions",
        "websiteUsedByScammer": "Website (URL) Used by the Scammer",
        "websiteDescription": "Provide any websites associated with the scammer.",
        "enterWebsiteURL": "Enter website URL",
        "addWebsite": "Add Website",
        "stolenTokenID": "Stolen Token ID",
        "tokenIDDescription": "List any token IDs that were stolen.",
        "enterTokenID": "Enter token ID",
        "addTokenID": "Add Token ID",
        "scammerIpAddress": "Scammer IP Address",
        "ipAddressDescription": "Provide any known IP addresses of the scammer.",
        "enterIpAddress": "Enter IP address",
        "addIpAddress": "Add IP Address",
        "scammerContact": "Scammer Contact (if available)",
        "contactDescription": "Any contact information of the scammer.",
        "enterScammerContact": "Enter scammer contact",
        "addContact": "Add Contact",
        // Step3.js 的翻譯
        "provideEvidence": "Provide Evidence",
        "descriptionPlaceholder": "Please describe the case with as many details as possible to support investigations. If you are posting publicly, make sure not to enter any personal information here.",
        "enterDescription": "Enter case description",
        "uploadEvidence": "Upload Evidence(Max 10)",
        "addFile": "Add File",

        // Step4.js 的翻譯
        "pleaseConfirmInfo": "Please confirm the following information and provide your personal details.",
        "reviewYourInformation": "Review Your Information",
        "personalInformation": "Personal Information",
        "personalInfoDescription": "Please fill in the following personal details so we can contact you.",
        "fullName": "Full Name",
        "enterFullName": "Enter your full name",
        "email": "Email",
        "enterEmail": "Enter your email",
        "phoneNumber": "Phone Number",
        "enterPhoneNumber": "Enter your phone number",
        "country": "Country",
        "enterCountry": "Enter your country",
        "city": "City",
        "enterCity": "Enter your city",
        "uploadedFiles": "Uploaded Files",
        "scammerAddresses":  "Transaction Information",
        "victimWalletAddress_step4": "Victim's Wallet Address",
        "scammerWalletAddress_step4": "Scammer's Wallet Address",
        "chain": "Blockchain",
        "date": "Date",
        "websites": "Websites",
        "tokenIDs": "Token IDs",
        "ipAddresses": "IP Addresses",
        "contacts": "Contacts",
        "noFile": "No file uploaded",
        "transactionScreenshots": "Transaction Screenshots",

        // ReportSteps 共用的翻譯
        "next": "Next",
        "previous": "Previous",
        "confirmAndSubmit": "Confirm and Submit",
        "submitReport": "Submit Report",
        "reportSubmitted": "Report Submitted Successfully",
        "incidentType": "Incident Type",
        "exchange": "Exchange",
        "pleaseCompleteFields": "Please complete all required fields",
        "selectedFile": "Selected File",
        "remove": "Remove",
        "guestIdNote": "Note: You are currently browsing as a guest. Please log in to save your report.",

      // Profile.js 的翻譯
      "loading": "Loading...",
      "profileInfo": "Profile Information",
      "name": "Name",
      "save": "Save",
      "enterValidPhoneNumber": "Please enter a valid phone number",
      "updateSuccess": "Update successful",
      "updateFailed": "Update failed, please try again later",
      "nickname": "Nickname",
      "uid": "User ID",
      "Taiwan, Province of China": "Taiwan",
      "walletAddresses": "User Wallet Addresses",
      "noWalletAddresses": "No wallet addresses linked",
      "addWallet": "Add Wallet",
      "enterUserWalletAddress": "Enter user wallet address",
      "walletAdded": "Wallet address added",
      "walletRemoved": "Wallet address removed",
      "walletRemoveFailed": "Failed to remove wallet address",
      "walletComment": "Comment",
      "editComment": "Edit Comment",
      "noComment": "No comment available",
      "removeWallet": "Remove Wallet",
      "commentUpdated": "Comment updated",


      // MyReports.js 的翻譯
      "myReports": "My Reports",
      "reportId": "Report ID",
      "exportAsPDF": "Export as PDF",
      "exportAsJSON": "Export as JSON",
      "addToFavorites": "Add to Favorites",
      "addedToFavorites": "Added to Favorites",
      "linkGuestReport": "Link Guest Report",
      "enterGuestId": "Enter Guest ID",
      "linkReport": "Link Report",
      "reportLinked": "Report successfully linked to your account",
      "errorLinkingReport": "Failed to link report, please check your Guest ID",
      "errorFetchingReports": "Error fetching reports",
      "errorAddingToFavorites": "Error adding to favorites",
      "fileTooLarge": "File is too large",
      "uploadFailed": "Upload failed",
      "edit": "Edit",
      "editReport": "Edit Report",
      "fieldUpdated": "Field updated",
      "delete": "Delete",
      "cancel": "Cancel",
      "evidenceFiles": "Evidence Files",
      "noEvidenceFilesAvailable": "No evidence files available",
      "uploadNewEvidenceFiles": "Upload New Evidence Files",
      "existingEvidenceFiles": "Existing Evidence Files",
      "addEvidenceFiles": "Add Evidence Files",
      "evidenceFilesUpdated": "Evidence files updated",
      "errorUpdatingEvidenceFiles": "Error updating evidence files",
      "reportDetails": "Report Details",
      

      // adminDashboard translations
      "manageUsers": "Manage Users",
      "manageArticles": "Manage Articles",
      "totalUsers": "Total Users",
      "totalArticles": "Total Articles",
      "accessDenied": "Access Denied",
      "manageVideos": "Manage Videos",
      "createVideo": "Create Video",
      "viewApiUsage": "View API Usage",

      // APIUsage.js translations
      "apiUsageStatistics": "API Usage Statistics",
      "endpoint": "Endpoint",
      "method": "HTTP Method",
      "usageCount": "Usage Count",
      "lastUsedAt": "Last Used At",
      "errorFetchingApiUsage": "Error fetching API usage data",

      // Article.js translations
      "articleManagement": "Article Management",
      "title": "Title",
      "createdAt": "Created At",
      "actions": "Actions",
      // AdminCreateArticle.js translations
      "createArticle": "Create Article",
      "content": "Content",
      "errorCreatingArticle": "Error creating article",
      "summary": "Summary",
      "tags": "Tags",
      "tagsPlaceholder": "Enter tags, separated by commas",
      "translation": "Translation",
      "translationPlaceholder": "Enter English translation content",
      "articleCreatedSuccess": "Article created successfully!",
      // ArticlesList.js translations
      "readMore": "Read More",
      // EditArticle.js translations
      "editArticle": "Edit Article",
      "articleTitle": "Article Title",
      "articleSummary": "Article Summary",
      "articleContent": "Article Content",
      "articleTags": "Article Tags",
      "tagsPlaceholder": "Enter tags, separated by commas",
      "errorUpdatingArticle": "Error updating article",

      // AdminVideos.js translations
      "videoManagement": "Video Management",
      // AdminCreateVideo.js translations
      "videoTitle": "Video Title",
      "videoSummary": "Video Summary",
      "videoTags": "Video Tags",
      "videoUrl": "Video URL",
      "videoCreatedSuccess": "Video created successfully!",
      "errorCreatingVideo": "Error creating video",
      // VideoDetails.js translations
      "details": "Details",
      "views": "Views",
      "likes": "Likes",
      "uploadDate": "Upload Date",
      "noTags": "No Tags",
      // EditVideo.js translations
      "editVideo": "Edit Video",

      // BlockchainAcademy.js translations
      "articles": "Articles",
      "academyArticlesDescription": "Read the latest blockchain articles and enhance your knowledge.",
      "videos": "Videos",
      "academyVideosDescription": "Watch blockchain tutorial videos to gain practical insights.",
      "resources": "Resources",
      "academyResourcesDescription": "Download or browse related technical resources.",
      "downloadResource": "Download Resource",
      "latestArticles": "Latest Articles",
      "latestVideos": "Latest Videos",
      "totalVideos": "Total Videos",
      "removedFromFavorites": "Removed from Favorites",
      "favoriteError": "An error occurred while adding to favorites",
      "favorited": "Added to Favorites",
      "favorite": "Add to Favorites",
      "shareOnFacebook": "Share on Facebook",
      "shareOnTwitter": "Share on Twitter",
      "notLoggedIn": "Not Logged In",
      "redirectingToGoogleLogin": "Redirecting to Google login, please wait...",


      // Maintenance.js translations
      "maintenanceMode": "Maintenance Mode",
      "maintenanceMessage": "We are currently performing system updates. Please try again later.",
      "goToHome": "Go to Home",


      // BecomePartner.js 的翻譯
      "becomePartner": "Become Our Partner",
      "companyName": "Company Name",
      "companyNamePlaceholder": "Enter your company name",
      "contactName": "Contact Person",
      "contactNamePlaceholder": "Enter your name",
      "phone": "Phone Number",
      "phonePlaceholder": "Enter your phone number",
      "emailPlaceholder": "Enter your email",
      "desiredFeatures": "Desired Features",
      "desiredFeaturesPlaceholder": "What features would you like in the future?",
      "assistance": "Assistance You Can Provide",
      "assistancePlaceholder": "What support can you provide (e.g., funding, resources)?",
      "otherContactDetails": "Other Contact Information",
      "otherContactDetailsPlaceholder": "Any other way to reach you",
      "additionalMessage": "Additional Message",
      "additionalMessagePlaceholder": "Anything else you'd like to say",
      "emailRequired": "Email is required.",
      "formSubmittedSuccessfully": "Form submitted successfully!",
      "formSubmissionFailed": "Failed to submit the form.",
      "submitting": "Submitting...",
    
    // AboutUs.js Translation
    "aboutUs": {
      "title": "About Us",
      "subtitle": "Discover Our Mission and Vision",
      "teamTitle": "Team Introduction and Product Origin",
      "teamDescription": "DamenKYT is a team of cryptocurrency enthusiasts, blockchain technology experts, and regulatory consultants from Taiwan. We deeply understand the potential and challenges of the cryptocurrency market, especially the increasing fraud issues in Taiwan. With passion and expertise, we aim to create a secure and transparent cryptocurrency trading environment, assist enterprises in regulatory compliance, and provide effective reporting tools for fraud victims. This is not just a technical mission but also our commitment to enhancing financial security in Taiwan.",
      "missionTitle": "Our Mission",
      "missionDescription": "Cryptocurrencies have created entirely new markets, making the global economy larger, fairer, and more deeply integrated. However, this is just the beginning of the potential of this transformative technology. To fully realize the value of cryptocurrencies, greater trust and transparency are essential. This is the mission of Damen KYT. We must advocate for clearer regulations, establish comprehensive audit standards, and implement robust compliance controls to support the sustained growth of cryptocurrencies and ensure their seamless integration into the global financial system. Through our compliance and investigation tools, Damen KYT is dedicated to helping achieve this vision. We provide banks, businesses, and government institutions with the confidence and expertise they need to foster the prosperity of this emerging digital economy.",
      "featuresTitle": "Our Core Features",
      "featureAMLTitle": "Anti-Money Laundering Monitoring",
      "featureAMLDescription": "We offer advanced Anti-Money Laundering (AML) technology, enabling real-time tracking of suspicious wallet address fund flows. This helps businesses and financial institutions identify potential risks and prevent illegal financial activities. Our platform quickly analyzes large volumes of transaction data, ensuring compliance and reducing financial crime risks, so every cryptocurrency transaction occurs in a safe and transparent environment.",
      "featureReportSupportTitle": "Reporting Support Services",
      "featureReportSupportDescription": "To assist fraud victims in handling cases more efficiently, Damen KYT provides easy-to-use reporting tools. These tools help users generate clear and concise report forms and intuitively organize relevant evidence required for filing a case. By simplifying the cumbersome reporting process, we enable victims to receive assistance faster and improve case handling efficiency."
    },

    // ContactUs.js Translation
      "contactUs": {
        "title": "Contact Us",
        "contactPrompt": "We will contact you as soon as possible.",
        "description": "If you are a victim seeking support, please report your case to generate the relevant data for faster assistance. For inquiries about existing reports, please provide your report ID for reference.",
        "nameLabel": "Name",
        "enterName": "Enter your name",
        "emailLabel": "Email",
        "enterEmail": "Enter your email address",
        "phoneLabel": "Phone",
        "enterPhone": "Enter your phone number",
        "subjectLabel": "Subject",
        "enterSubject": "Enter your subject",
        "contentLabel": "Content",
        "enterMessage": "Enter your inquiry or message",
        "submit": "Submit Data",
        "error": {
          "submissionFailed": "Failed to submit the contact form. Please try again later."
        }
      },
    
    

    "services": {
    "title": "Our Services",
    "subtitle": "We are dedicated to providing the most professional blockchain and Web3 solutions.",
    "blockchainFraud": {
      "title": "Blockchain Anti-Fraud Solutions",
      "description": "Assisting businesses with fund monitoring, risk assessment, and report generation to ensure financial security."
    },
    "web3Education": {
      "title": "Web3 Education and Training",
      "description": "Offering blockchain fundamentals courses, wallet safety operations, and fraud prevention awareness."
    },
    "blockchainConsulting": {
      "title": "Blockchain Technical Consulting",
      "description": "Providing consulting services related to blockchain fund flow tracking technology."
    },
    "riskManagement": {
      "title": "Data and Risk Management",
      "description": "Enabling fund flow monitoring and automated compliance reporting."
    },
    "process": {
      "title": "Service Process",
      "step1": "Needs Assessment",
      "description1": "Understand your needs and provide professional advice.",
      "step2": "Solution Design",
      "description2": "Tailor a customized solution based on your requirements.",
      "step3": "Implementation and Optimization",
      "description3": "Professional team implements the solution and continuously optimizes it.",
      "step4": "Ongoing Support",
      "description4": "Providing reliable technical support and service upgrades."
    }
  },

  // UpdateLog.js 的翻譯
  // AdminUpdateLog.js 的翻譯
    "adminUpdateLog": "Update Log Management",
    "manageUpdateLogs": "Manage Update Logs",
    "updateLogs": "Update Logs",
    "viewUpdateHistory": "View Update History",
    "enterVersion": "Enter Version Number",
    "enterDescription": "Enter Update Description",
    "submit": "Submit",
    "updateLogHistory": "Update Log History",
    "version": "Version",
    "description": "Description",
    "updatedOn": "Updated On",
    "noLogsFound": "No update logs found at the moment.",
    "fillAllFields": "Please fill in all fields.",
    "fetchLogsError": "Failed to fetch logs.",
    "addLogError": "Failed to add update log.",
    "logAddedSuccessfully": "Log added successfully.",
    "updateLogError": "Failed to edit the log.",
    "logUpdatedSuccessfully": "Log updated successfully.",
    "edit": "Edit",
    "update": "Update",
    "lastEdited": "Last Edited",
    "never": "Never",

  // PrivacyPolicy.js Translation
  privacyPolicy: {
    title: 'Privacy Policy',
    intro: `Welcome to "https://kyt.damentec.com/" (hereinafter referred to as this Website). In order to allow you to use the various services and information on this Website with peace of mind, we are committed to protecting your privacy and have formulated the following privacy policy. Please read the following content carefully:`,
    section1: {
      title: 'I. Scope of the Privacy Protection Policy',
      content: `This policy applies to how this Website handles personal identification data that you provide or that we automatically collect when you use our services. It does not apply to other websites or personnel not entrusted by this Website.`,
    },
    section2: {
      title: 'II. Collection, Processing, and Use of Personal Data',
      items: [
        `Collection Scope:
- When you use the Google login feature, we collect your basic account information (such as email address, name).
- When you fill out forms or provide other information, we collect the personal information you provide, including but not limited to name, contact information, and address.
- If you interact through a blockchain wallet, we collect your public address and related records.`,
        `Purpose of Use:
- Service Provision: Ensure that you can use all the functions of this Website smoothly, such as account management, transaction record inquiries, etc.
- System Analysis: Use statistical data to understand user needs, optimize user experience, and improve service performance.
- Legal Purposes: Comply with legal regulations and provide relevant data to authorities when necessary.`,
        `Data Retention:
- User data is stored only on secure servers and will be retained for 6 months after account closure or the maximum period required by law.`,
      ],
    },
    section3: {
      title: 'III. Data Protection',
      content: [
        `This Website uses advanced encryption technologies (such as HTTPS) to protect data transmission, and employs firewalls and intrusion detection systems to ensure data security.`,
        `Your personal data is only accessible to authorized personnel, all of whom are required to sign confidentiality agreements. Any violation will be pursued in accordance with the law.`,
      ],
    },
    section4: {
      title: 'IV. External Links',
      content: `This Website may contain links to other websites. The privacy policies of those linked websites do not apply to this Website. We recommend that you refer to the privacy statements of those respective websites.`,
    },
    section5: {
      title: 'V. Policy on Sharing Personal Data with Third Parties',
      items: [
        `Unless under the following circumstances, this Website will not provide your personal data to third parties:`,
        `When required by law or to fulfill legal obligations.`,
        `When it is necessary to share with partners (e.g., payment service providers) to provide services or complete transactions.`,
        `With your explicit consent.`,
      ],
    },
    section6: {
      title: 'VI. Use of Cookies and Similar Technologies',
      content: [
        `This Website uses cookies and similar technologies to enhance the user experience, including functional cookies and performance analysis cookies.`,
        `You can manage or refuse cookies through your browser settings, but it may affect the normal operation of some functions.`,
      ],
    },
    section7: {
      title: 'VII. Amendments to the Privacy Policy',
      content: `This policy will be revised in response to business needs or regulatory changes. The revised content will be posted on this Website, and users will be notified via email or website pop-ups. If you continue to use this Website after the policy update, you are deemed to have accepted the revised content.`,
    },
  },
  // ===================== 服務條款翻譯：英文 =====================
  termsOfService: {
    title: 'Terms of Service',
    intro: `Welcome to the services provided by "https://kyt.damentec.com/". Please read the following terms carefully. By using this Website, you are deemed to agree to these terms.`,
    section1: {
      title: 'I. Service Content',
      content: [
        `This Website provides services including but not limited to account management and transaction record inquiries.`,
        `You may be required to undergo identity verification (e.g., Google login) to use certain features of this Website.`,
      ],
    },
    section2: {
      title: 'II. User Eligibility',
      content: [
        `Users must have full legal capacity. If the user is a minor, usage must be under the consent of a legal guardian.`,
        `If a user violates these terms or any legal provisions, this Website reserves the right to suspend or terminate the service.`,
      ],
    },
    section3: {
      title: 'III. User Registration and Account Security',
      content: [
        `Users must ensure the accuracy of registration information and properly safeguard their account credentials.`,
        `When using Google login, please ensure you consent to grant this Website access to necessary account information.`,
        `If unauthorized account use is discovered, please notify this Website immediately. The user is responsible for all actions arising from the use of the account.`,
      ],
    },
    section4: {
      title: 'IV. On-Chain Wallet Data',
      content: [
        `When logging in via a blockchain wallet, this Website will collect and record your public address.`,
        `This Website promises to use transaction data only for legitimate purposes and to protect relevant privacy.`,
      ],
    },
    section5: {
      title: 'V. Intellectual Property Rights',
      content: [
        `All content on this Website (including text, images, and designs) is protected by intellectual property rights and may not be used without authorization.`,
        `If the content published by users involves infringement, they shall bear the relevant legal responsibilities. This Website reserves the right to remove infringing content.`,
      ],
    },
    section6: {
      title: 'VI. Limitation of Liability',
      content: [
        `This Website shall not be held liable for service interruptions or losses caused by force majeure or factors beyond the control of this Website.`,
        `This Website does not assume any responsibility for the accuracy, completeness, or legality of on-chain transaction data.`,
      ],
    },
    section7: {
      title: 'VII. Modification of Terms',
      content: [
        `This Website reserves the right to modify these terms. The revised terms will take effect immediately and be announced on this Website.`,
        `After the terms are modified, users will be notified via email or website pop-ups. If you continue to use this Website, you are deemed to accept the revised terms.`,
      ],
    },
  },

  // Faqs.js 的翻譯
    "faqs": {
    "title": "FAQs",
    "searchDescription": "If you have any questions, please check the FAQs below or visit",
    "contact": "Contact Us",
    "searchContact": "for further assistance.",
    "searchPlaceholder": "Enter keywords to search...",
    "searchButton": "Search",
    "searchResults": "Search Results",
    "noResults": "No relevant results found",
    "categoriesTitle": "FAQ Categories",
    "privacyPolicy": {
      "title": "Privacy Policy"
    },
    "commonQuestions": {
      "title": "Common Questions",
      "q1": {
        "question": "What is DamenKYT?",
        "answer": "DamenKYT is a Web3 anti-fraud platform specializing in blockchain risk management. It provides real-time wallet risk assessments, cross-chain fund tracking, and reporting support."
      },
      "q2": {
        "question": "How do I check wallet risk?",
        "answer": "You can enter a wallet address on the 'Wallet Inquiry' page, and the platform will generate a detailed risk assessment report."
      },
      "q3": {
        "question": "What is blockchain?",
        "answer": "Blockchain is a decentralized technology that ensures data transparency and immutability."
      },
      "q4": {
        "question": "How do I report a suspicious address?",
        "answer": "You can submit a suspicious address along with relevant evidence through the reporting function. The platform will help generate a report for law enforcement. Alternatively, you can search for a wallet on the 'Wallet Inquiry' page and select 'This is a suspicious wallet.'"
      },
      "q5": {
        "question": "What services does DamenKYT provide?",
        "answer": "We offer wallet risk assessment, cross-chain fund tracking, and comprehensive reporting support services."
      }
    },
    "caseReport": {
      "title": "Case Reporting",
      "q1": {
        "question": "How do I submit a case report?",
        "answer": "Click the 'Report Your Case' button, fill in the required information, and submit. You can find your reported cases in the 'Member Area' and export a report to personally submit to your local police station."
      },
      "q2": {
        "question": "What information is required for a case report?",
        "answer": "You need to provide wallet addresses, transaction records, and relevant evidence."
      },
      "q3": {
        "question": "How long does the review process take?",
        "answer": "The review process typically takes 24 to 48 hours. If your report contains errors, it may be revoked."
      },
      "q4": {
        "question": "Can I modify my case report after submission?",
        "answer": "Yes, you can modify your report in the 'Member Area' after submission."
      },
      "q5": {
        "question": "Who can view my case report?",
        "answer": "If you select 'Publish report on DamenKYT,' your report (excluding personal data) will be made public. If you select 'Submit report privately,' only authorized internal personnel will have access to your report to protect your privacy."
      }
    },
    "fraudSupport": {
      "title": "Fraud Support",
      "q1": {
        "question": "How can I get fraud support?",
        "answer": "Please contact our support team through the support page, and we will provide professional assistance."
      },
      "q2": {
        "question": "What are the operating hours for fraud support services?",
        "answer": "Our support team is available from Monday to Friday (excluding public holidays), from 09:00 to 18:00."
      },
      "q3": {
        "question": "How does the platform prevent fraud?",
        "answer": "We use real-time monitoring, risk assessments, and cross-chain tracking technologies to prevent fraud."
      },
      "q4": {
        "question": "How can I identify high-risk wallets?",
        "answer": "The platform evaluates wallet risk based on multiple indicators and provides a detailed report."
      },
      "q5": {
        "question": "Can I report fraud anonymously?",
        "answer": "Yes, you can choose to report fraud anonymously to protect your personal privacy."
      }
    }
  },

  // PricingPlan.js 的翻譯
  "pricingPlan": {
    "title": "Platform Plan",
    "subtitle": "Unleash your blockchain investigation journey with us, starting right here!",
    "individual": "Individual",
    "team": "Team",
    "forCollaboration": "For Collaboration",
    "monthly": "Monthly",
    "semiAnnually": "Semi-Annually",
    "annually": "Annually",
    "exclusiveOffer": "Exclusive Offer",
    "experiencePro": "Experience Pro",
    "for3Days": "for 3 Days",
    "at": "at",
    "getNow": "Get now",
    "free": "Free",
    "basic": "Basic",
    "pro": "Pro",
    "ultra": "Ultra",
    "forAnyoneInterested": "For anyone interested in crypto tracking.",
    "forEverydayInvestors": "For everyday investors and LPs seeking basic DYOR capabilities.",
    "forProfessional": "For professional and institutional investors, and on-chain analysts.",
    "forLawEnforcement": "For law enforcement and investigative agencies.",
    "month": "month",
    "cryptoAccepted": "Crypto Accepted",
    "subscribe": "Subscribe",
    "blockchains": "Blockchains",
    "essentialInvestigation": "Essential investigation features",
    "everythingInFree": "Everything in Free, plus",
    "everythingInBasic": "Everything in Basic, plus",
    "abilityToEditSharedCharts": "Ability to edit shared charts",
    "addMemosToCharts": "Add memos to charts",
    "expandedInterChainTracker": "Expanded InterChain Tracker & Advanced Analysis access",
    "solana": "Solana",
    "addressTxBatch": "Address/Tx batch importing",
    "customWatermark": "Custom watermark",
    "defaultWatermarkRemoval": "Default watermark removal",
    "noLimitation": "No limitation",
    "best": "BEST",
    "subscriptionSuccess": "Subscription successful!",
    "error": {
      "subscriptionFailed": "Failed to subscribe, please try again later."
    }
  },

  // ApiPrice.js
  "ApiPrice": {
    "apis": "APIs",
    "description": "Enhance your product's compliance integration with our industry-leading API for compliance score and address labels.",
    "individual": "Individual",
    "team": "Team",
    "monthly": "Monthly",
    "annually": "Annually",
    "periodAnnual": "for 12 months",
    "month": "per month",
    "startFree": "Start Free",
    "free": "Free",
    "basic-label": "Basic - Label",
    "basic-risk": "Basic - Risk Assessment",
    "advanced": "Advanced - Label & Risk",
    "best": "BEST",
    "labelRiskAPI": "Wallet Label API",
    "riskAssessment": "Wallet Risk Assessment",
    "advancedQuota": "Quota: 10,000 requests per day",
    "advancedLimit": "Limit: 5 requests per second",
    "prioritySupport": "Priority Technical Support",
    "quotaUpgrade": "Additional Request Quota",
    "advancedSupport": "Advanced Technical Support",
    "additionalRequests": "Additional 1,000 requests per day",
    "dedicatedSupport": "Dedicated technical support manager",
    "needMoreAPICalls": "Need More API Calls?",
    "getAddOns": "Get Add-Ons!",
    "contactUs": "Contact Us",
    "contactDescription": "Whether you need to increase your API call quota, require professional technical support, or have any other needs, we are here to help. Feel free to contact us anytime, and we will provide you with the most suitable solution.",
    "featurefree0": "Includes wallet labels and risk assessment",
    "featurefree1": "Quota: 10 requests per day",
    "featurefree2": "Support for 13 major blockchains",
    "featurefree3": "Basic query functionality",
    "featurebasic-label0": "Wallet Label API",
    "featurebasic-label1": "Quota: 1,000 requests per day",
    "featurebasic-label2": "Limit: 5 requests per second",
    "featurebasic-label3": "Support for all major blockchains",
    "featurebasic-risk0": "Wallet Risk Assessment API",
    "featurebasic-risk1": "Quota: 1,000 requests per day",
    "featurebasic-risk2": "Limit: 5 requests per second",
    "featurebasic-risk3": "Support for all major blockchains",
    "advancedQuotaPrefix": "Quota: ",
    "advancedQuotaSuffix": " requests per day"
  },

    // AdminUsers.js
  "role": "Role",
  "searchUser": 'Search user name or email',
  "registrationDate": 'Registration date',
  "changeRole": 'Change role',
  "userManagement": 'User Management',

  // DonationPage.js English
  "supportAntiScamPlatform": "Support the DamenKYT anti-scam platform",
  "donationWillHelp": "Your donation will help us continue to provide free anti-scam services, protecting more people from scam threats.",
  "quantity": "Quantity",
  "totalAmount": "Total amount",
  "processing": "Processing",
  "donateNow": "Donate now",
  "quickDonation": "Quick Donation",
  "quickDonationDesc": "Choose a donation amount and set quantity to quickly support us",
  "customDonation": "Custom Donation",
  "customDonationDesc": "Enter a specific amount you wish to donate",
  "enterAmount": "Enter amount",
  "use": "Use",
  "donorInformation": "Donor Information",
  "donorInfoDesc": "Let us know you, we will send a thank you letter to your email (optional)",
  "donateAnonymously": "Donate anonymously",
  "donorName": "Name",
  "donorEmail": "Email",
  "donorNote": "Message",
  "donorNotePlaceholder": "Leave a message to us...",
  "pleaseEnterValidAmount": "Please enter a valid amount",
  "donationProcessFailed": "Donation process failed",
  "donationProcessFailedTryAgain": "Donation process failed, please try again later",
  
  // DonationSuccessPage.js English
  "donationSuccessThankYou": "Donation successful, thank you for your support!",
  "donationSuccessMessage": "Your generous donation will help us continue to provide free anti-scam services, protecting more people from scam threats. We sincerely thank you for your contribution to building a safer online environment.",
  "backToHome": "Back to home",
  "donateAgain": "Donate again",
  
  
  

  // DonationTransparencyPage.js Translation
  "donationTransparency": "Donation Transparency",
  "donationTransparency.subtitle": "How we utilize your donations to create a safer blockchain environment",
  "donationTransparency.introduction": "Donation Transparency Policy",
  "donationTransparency.introText": "At DamenKYT, we believe in complete transparency regarding the use of funds generously donated by our supporters. This page provides a detailed breakdown of how your donations are utilized to improve our platform and expand our anti-scam initiatives. We are committed to using every contribution effectively to create a safer blockchain environment for all users.",
  "donationTransparency.howWeUse": "How We Use Your Donations",
  "donationTransparency.platformDevelopment": "Platform Development",
  "donationTransparency.platformDevelopmentText": "Funds allocated to improving our technical infrastructure, enhancing the user interface, and developing new features to better serve users in identifying and preventing scams.",
  "donationTransparency.educationInitiatives": "Education Initiatives",
  "donationTransparency.educationInitiativesText": "Supporting our Blockchain Academy to create comprehensive educational content that helps users understand blockchain security and recognize common scam tactics.",
  "donationTransparency.researchPrograms": "Research Programs",
  "donationTransparency.researchProgramsText": "Investing in ongoing research to identify emerging scam patterns and develop advanced detection algorithms to stay ahead of fraudsters.",
  "donationTransparency.scamPreventionTools": "Scam Prevention Tools",
  "donationTransparency.scamPreventionToolsText": "Developing and maintaining tools like wallet risk assessment, cross-chain fund tracking, and AI prediction models to help users navigate the blockchain ecosystem safely.",
  "donationTransparency.donationReport": "Donation Allocation Report",
  "donationTransparency.donationReportText": "Below is a summary of how donations have been allocated across our various initiatives. We update this information regularly to ensure full transparency.",
  "donationTransparency.date": "Date",
  "donationTransparency.amount": "Amount",
  "donationTransparency.usage": "Usage",
  "donationTransparency.totalDonation": "Total Donations Received",
  "donationTransparency.antiScamTech": "Anti-Scam Technology Development",
  "donationTransparency.websiteDevelopment": "Website and Platform Enhancement",
  "donationTransparency.educationProgram": "Blockchain Education Program",
  "donationTransparency.serverMaintenance": "Server and Infrastructure Maintenance",
  "donationTransparency.aiRiskPrediction": "AI Risk Prediction Model Development",
  "donationTransparency.thankYou": "Thank You for Your Support",
  "donationTransparency.thankYouText": "We are deeply grateful for your contributions. Your support enables us to continue our mission of making the blockchain ecosystem safer for everyone. Together, we are building a more secure digital future.",
  
  },},
  zh: {
    translation: {
      // FeedbackButton.js 的翻譯
      "feedback": "意見回饋",
      "leaveFeedback": "留下您的意見",
      "feedbackPlaceholder": "請輸入您的意見...",
      "feedbackSubmitted": "意見已提交，謝謝您的回饋！",
      "feedbackSubmitError": "提交失敗，請稍後再試。",
      "submit": "提交",

      // CookieConsent.js 的翻譯
      "cookieConsentMessage": "本網站使用 cookies 以提供更好的使用體驗。點擊同意即表示您接受我們的隱私政策。",
      "agree": "同意",

      // WalletRisk.js 的翻譯
      "walletRiskAssessment": "錢包地址風險評估",
      "walletSearchDescription": "先查詢，再快速回報可疑錢包地址",
      "report": "填寫交易報告",
      "assessRisk": "評估風險",
      "mainEntity": "主體",
      "nameTag": "標籤",
      "walletRiskDetails": "錢包地址標籤查詢結果",
      "sanctionCheckResult": "制裁檢查結果",
      "walletSanctioned": "該錢包地址已受到制裁。",
      "walletNotSanctioned": "該錢包地址未受到制裁。",
      "noWalletTags": "未找到該錢包地址的標籤。",
      "unknown": "未知",
      "search": "查詢",
      "thisIsMyWallet": "這是我的錢包",
      "thisIsSuspiciousWallet": "這是可疑錢包",
      "walletAddedToWhitelist": "已將此錢包地址添加到會員資訊",
      "errorAddingWalletToWhitelist": "將錢包地址添加到會員資訊時出錯",
      "walletAddedToBlacklist": "已將此錢包地址添加到風險名單",
      "errorAddingWalletToBlacklist": "將錢包地址添加到風險名單時出錯",
      "enterValidWalletAddress": "請輸入有效的錢包地址",
      "enterComment": "輸入備註",
      "labelScam": "詐騙",
      "labelPhishing": "網路釣魚",
      "labelMoneyLaundering": "洗錢",
      "labelFraud": "欺詐",
      "complianceRiskScore": "風險評估結果",
      "riskScore": "風險分數",
      "riskIndicators": "風險指標",
      "indicatorName": "名稱",
      "indicatorCode": "代碼",
      "sanctionSource": "制裁來源",
      "queriedAddress": "查詢的錢包地址",
      "blocked" : "已封鎖",
      "riskLabelQueryFailed": "風險標籤查詢失敗",
      "sanctionQueryFailed" : "制裁查詢失敗",
      "complianceRiskQueryFailed" : "風險評估查詢失敗",
      "noWalletDataYet": "尚無此錢包地址的資料",
      "noSanctionDataYet": "尚無此錢包地址的制裁資料",
      "noComplianceDataYet": "尚無此錢包地址的風險評估資料",


      // 首頁的翻譯
      "welcomeToApp": "DamenKYT",
      "appDescription": "專為 Web3 使用者設計的反詐騙與資安平台，提供錢包風險查詢、AI 風險預測、詐騙路徑分析等多種工具，幫助用戶識別並防範詐騙行為，提升 Web3 生態的安全性。",
      "guestReportInfo": "訪客報案資訊",
      "guestId": "訪客編號",
      "learnMore": "了解更多",
      "generateReport": "生成報案資料",
      "errorFetchingGuestReport": "獲取訪客報案資訊時出錯",
      "recentSuspiciousReports": "近期通報詐騙案件",
      "recentReports": "近期通報詐騙案件",
      "siteName": "站點名稱",
      "suspiciousWebsite": "可疑釣魚網站",
      "suspiciousPhishingSite": "可疑釣魚網站",
      "highRiskPhishingWebsites": "高危釣魚網站",
      "reportCount": "通報數量",
      "reportDomain": "通報域名",
      "reportWallet": "通報錢包地址",
      "suspiciousReportDetails": "可疑報告詳情",
      "reportDescription": "報告的簡要描述",
      "reportDomainButton": "回報域名",
      "blockchainAcademy": "區塊鏈學院",
      "academyImagePlaceholder": "學院圖片佔位",
      "academyArticleTitle": "學院文章標題",
      "academyArticleDescription": "學院文章簡述",
      "incidentType": "事件類型",
      "description": "描述",
      "inputUrlOrAddress": "輸入網址或區塊鏈地址",
      "search": "搜索",
      "whyUseApp": "為什麼使用 DamenKYT",
      "whyUseAppDescription": "了解 DamenKYT 如何協助您防範詐騙與提升資安，讓您的 Web3 體驗更安全。",
      "domainReports": "通報域名",
      "walletReports": "通報錢包地址",
      "domainName": "域名",
      "walletAddress": "錢包地址",
      "phishingPage": "釣魚頁面",
      "category1": "分類1",
      "articleDate": "YYYY/MM/DD",
      "viewCount": "瀏覽",
      "likeCount": "喜歡",
      "blockchainAcademyTitle" : "區塊鏈學院",
      "blockchainAcademyDescription" : "閱讀最新的區塊鏈文章!",

      // 導航列的翻譯
      "generateReport": "報告您的案例",
      "pathAnalysis": "受騙路徑分析",
      "walletRiskQuery": "錢包查詢",
      "aiRiskPrediction": "AI風險預測",
      "blockchainAcademy": "區塊鏈學院",
      "memberArea": "會員專區",
      "dashboard": "儀表板",
      "memberInfo": "會員資訊",
      "favorites": "我的收藏",
      "toggleMode": "深淺模式切換",
      "login": "登入",
      "logout": "登出",
      "adminDashboard" : "管理員儀表板",
      "welcomeToDamenKYT": "歡迎來到 DamenKYT",
      "loginToAccessMore": "登入後可以使用更多功能，如專屬會員專區、個人錢包地址管理、區塊鏈學院點讚及收藏等",
      "loginWithGoogle": "使用 Google 登入",

      // Footer 的翻譯
      "companyInfo": "公司資訊",
      "kaohsiungOffice": "高雄辦公室",
      "kaohsiungAddress": "苓雅區自強三路5號29樓之7",
      "taipeiOffice": "台北辦公室",
      "taipeiAddress": "中山區民權東路三段37號12樓",
      "contactPhone": "電話",
      "contactEmail": "電子郵件",
      "quickLinks": "快速導航",
      "aboutUs": "關於我們",
      "services": "服務",
      "reportSystem": "報案系統",
      "contactUs": "聯絡我們",
      "legalAndPolicy": "法律與政策",
      "privacyPolicy": "隱私政策",
      "termsOfService": "服務條款",
      "socialMedia": "社交媒體",
      "allRightsReserved": "版權所有",
      "contactInfo": "聯繫我們",
      "companyName": "公司名稱",
      "taxID": "統一編號",
      "customerEmail": "客服信箱",
      "companyWebsite": "官方網站",
      "donation": "捐款",
      "supportUs": "支持我們",
      "donationTransparency": "捐款透明度",


      // ReportSteps 的翻譯
        // StepIndicator 的翻譯
        "caseDetails": "案件詳情",
        "scammerInformation": "詐騙者資訊",
        "description": "描述及證據上傳",
        "contactSupport": "聯繫及確認",
        "confirm" : "確認",

        // ScamQuiz 的翻譯
        "notSureWhatToChoose": "不確定該選什麼嗎？",
        "takeQuizDescription": "進行詐騙測驗，幫助您找到答案。",
        "takeScamQuiz": "詐騙類型測驗",
        "howDidItOccur": "詐騙是如何發生的？",
        "specifyFraudType": "指定詐騙類型",
        "blackmailedSendCrypto": "我被勒索發送加密貨幣",
        "blackmailSextortion_description": "威脅我公開敏感的性資訊",
        "blackmailRansomware_description": "封鎖我的系統並要求付款才能解鎖",
        "trickedTransferCrypto": "我被騙轉移加密貨幣",
        "unauthorizedPayment": "有人未經我授權進行了付款",
        "specifyBlackmailType": "請具體說明勒索類型",
        "specifyHackType": "請指定駭客類型",
        "fraudNftAirdrop_description": "詐騙者發送虛假的NFT以騙取受害者。",
        "fraudPhishing_description": "詐騙者通過假網站或電子郵件誘騙受害者泄露敏感訊息。",
        "fraudImpersonation_description": "詐騙者冒充他人以欺騙受害者。",
        "fraudDonation_description": "詐騙者冒充慈善機構來騙取捐款。",
        "fraudRomance_description": "詐騙者通過虛假戀愛關係騙取錢財。",
        "fraudPigButchering_description": "詐騙者誘騙受害者投資虛假的財務計劃。",
        "fraudFakeProject_description": "詐騙者推廣虛假項目以騙取投資者的錢財。",
        "fraudRugPull_description": "詐騙者突然從項目中提取資金，讓投資者一無所獲。",
        "fraudFakeReturns_description": "詐騙者承諾高回報但從未兌現。",
        "hackSimSwap_description": "駭客控制了我的手機號碼以訪問我的帳戶。",
        "hackContractExploit_description":"我可能與被利用的智能合約互動",
        "hackPasswordCrack_description": "駭客破解了我的密碼以訪問我的帳戶",
        "hackPrivateKeyLeak_description": "我的私鑰外洩被駭客取得並竊取我的帳戶",
        "close": "關閉",
        "yourIncidentTypeIs": "您的事件類型為",

        // Step1 下拉選單
        "selectIncidentType": "選擇事件類型",
        "pleaseSelect": "請選擇",
        "blackmailSextortion": "勒索 - 色情敲詐",
        "blackmailRansomware": "勒索 - 勒索軟體",
        "blackmailOther": "勒索 - 其他",
        "fraudNftAirdrop": "詐騙 - NFT 空投詐騙",
        "fraudPhishing": "詐騙 - 網絡釣魚",
        "fraudImpersonation": "詐騙 - 假冒詐騙",
        "fraudDonation": "詐騙 - 捐款詐騙",
        "fraudRomance": "詐騙 - 愛情詐騙",
        "fraudPigButchering": "詐騙 - 殺豬盤詐騙",
        "fraudFakeProject": "詐騙 - 假投資項目",
        "fraudRugPull": "詐騙 - 拉地毯詐騙(虛擬資產投資騙局)",
        "fraudFakeReturns": "詐騙 - 假投資回報",
        "fraudOther": "詐騙 - 其他",
        "hackSimSwap": "駭客 - SIM劫持",
        "hackContractExploit": "駭客 - 合約漏洞利用",
        "hackPasswordCrack": "駭客 - 密碼破解",
        "hackPrivateKeyLeak": "駭客 - 私鑰外洩",
        "hackOther": "駭客 - 其他",
        "other": "其他",
        "pleaseSpecify": "請具體說明",
        "pleaseSpecifyIncident": "請具體說明事件類型",
        "reportSharing": "報告分享",
        "postReportOnDamenKYT": "在 DamenKYT上發佈報告",
        "publicReportInfo": "大多數用戶選擇公開報告以警告社群。所有個人訊息將保持隱私。DamenKYT永遠不會在平台上分享您的個人訊息。",
        "submitReportPrivately": "僅私下提交報告",
        "pleaseSelectIncidentType": "請選擇事件類型",
        "pleaseSelectReportType": "請選擇報告分享方式",
        // Step2.js 的翻譯
        "scammerInfoDescription": "請盡可能提供有關詐騙者的詳細資訊。",
        "transactionDetails": "受騙的交易內容",
        "transactionDetailsDescription": "請輸入資金從您的錢包轉移到詐騙者錢包時的交易內容，如有多筆交易請點選下方添加更多交易。",
        "victimWalletAddress": "受害者的錢包地址",
        "enterVictimWalletAddress": "輸入受害者的錢包地址",
        "scammerWalletAddress": "詐騙者的錢包地址",
        "enterScammerWalletAddress": "輸入詐騙者錢包地址",
        "selectChain": "選擇區塊鏈",
        "dateOfFraud": "受騙的時間",
        "amount": "金額",
        "enterAmount": "輸入金額",
        "currency": "幣種",
        "enterCurrency": "輸入幣種",
        "transactionID": "交易ID（哈希值）",
        "uploadTransactionScreenshot": "上傳交易截圖",
        "enterTransactionID": "輸入交易ID",
        "addTransactions": "添加更多交易",
        "websiteUsedByScammer": "詐騙者使用的網站（URL）",
        "websiteDescription": "提供與詐騙者相關的任何網站。",
        "enterWebsiteURL": "輸入網站URL",
        "addWebsite": "添加網站",
        "stolenTokenID": "被盜的代幣ID",
        "tokenIDDescription": "如果您有任何被盜的NFT，請填寫該代幣的ID。",
        "enterTokenID": "輸入代幣ID",
        "addTokenID": "添加代幣ID",
        "scammerIpAddress": "詐騙者的IP地址",
        "ipAddressDescription": "提供詐騙者的任何已知IP地址。",
        "enterIpAddress": "輸入IP地址",
        "addIpAddress": "添加IP地址",
        "scammerContact": "詐騙者的聯絡方式（如果有）",
        "contactDescription": "任何詐騙者的聯絡方式。",
        "enterScammerContact": "輸入詐騙者的聯絡方式",
        "addContact": "添加聯絡方式",
        // Step3.js 的翻譯
        "provideEvidence": "提供證據",
        "descriptionPlaceholder": "請盡可能詳細地描述案件以支持調查。如果您公開發布，請確保不要在此處輸入任何個人訊息。",
        "enterDescription": "輸入案件描述",
        "uploadEvidence": "上傳證據(最多10個)",
        "addFile": "添加檔案",

        // Step4.js 的翻譯
        "pleaseConfirmInfo": "請確認以下資訊，並填寫您的個人資料。",
        "reviewYourInformation": "查看您的資訊",
        "personalInformation": "個人資料",
        "personalInfoDescription": "請填寫以下個人資料，以便我們與您聯繫。",
        "fullName": "姓名",
        "enterFullName": "輸入您的姓名",
        "email": "電子郵件",
        "enterEmail": "輸入您的電子郵件",
        "phoneNumber": "電話號碼",
        "enterPhoneNumber": "輸入您的電話號碼",
        "country": "國家",
        "enterCountry": "輸入您的國家",
        "city": "城市",
        "enterCity": "輸入您的城市",
        "uploadedFiles": "上傳的文件",
        "scammerAddresses": "受害交易資訊",
        "victimWalletAddress_step4": "受害者的錢包地址",
        "scammerWalletAddress_step4": "詐騙者的錢包地址",
        "chain": "區塊鏈",
        "date": "日期",
        "websites": "網站",
        "tokenIDs": "代幣ID",
        "ipAddresses": "IP地址",
        "contacts": "聯絡方式",
        "noFile": "未上傳文件",
        "transactionScreenshots": "交易截圖",


        // ReportSteps 共用的翻譯
        "next": "下一步",
        "previous": "上一步",
        "confirmAndSubmit": "確認並提交",
        "submitReport": "提交報告",
        "reportSubmitted": "報告提交成功",
        "incidentType": "事件類型",
        "exchange": "交易所",
        "pleaseCompleteFields": "請完成所有必填欄位",
        "selectedFile": "選擇的文件",
        "remove": "移除",
        "guestIdNote": "請記錄您的訪客標識符，您可以稍後登入並關聯此案件: ",


        // ReportList.js 的翻譯
        "errorFetchingReports": "取得案件資料失敗",
        "totalAlerts": "總通報數",
        "totalEstimatedLoss": "總損失估計",
        "alertsIn7D": "7 日內通報數",
        "lossIn7D": "7 日內損失估計",
        "searchPlaceholder": "請輸入關鍵字搜尋",
        "filter1D": "1日",
        "filter7D": "7日",
        "filter30D": "30日",
        "filterAll": "全部",
        "age": "時間",
        "phishingType": "詐騙類型",
        "potentialPhishingTx": "潛在詐騙交易",
        "scammer": "詐騙者地址",
        "victim": "受害者地址",
        "lossAmount": "損失金額",
        "lossCurrency": "損失幣種",
        "detail": "詳細內容",
        "noData": "無資料",
        "noWebsiteInfo": "無網站資訊",
        "phishingUrl": "詐騙網址",
        "noWalletInfo": "無錢包資訊",
        "noTokenInfo": "無代幣資訊",


        // PublicReportDetails.js 的翻譯
        "basicInformation": "基本資訊",
        "location": "地區",


      // Profile.js 的翻譯
      "loading": "載入中...",
      "profileInfo": "會員資訊",
      "name": "姓名",
      "save": "保存",
      "enterValidPhoneNumber": "請輸入有效的手機號碼",
      "updateSuccess": "更新成功",
      "updateFailed": "更新失敗，請稍後再試",
      "nickname": "暱稱",
      "uid": "用戶 ID",
      "Taiwan, Province of China": "臺灣",
      "walletAddresses": "用戶錢包地址",
      "noWalletAddresses": "尚無綁定的錢包地址",
      "addWallet": "新增地址",
      "enterUserWalletAddress": "輸入用戶錢包地址",
      "walletAdded": "錢包地址已新增",
      "walletRemoved": "錢包地址已刪除",
      "walletRemoveFailed": "刪除錢包地址失敗",
      "walletComment": "錢包備註",
      "editComment": "編輯備註",
      "noComment": "暫無備註",
      "removeWallet": "刪除錢包",
      "commentUpdated": "備註已更新",

      

      // MyReports.js 的翻譯
      "myReports": "我的案件",
      "reportId": "案件編號",
      "exportAsPDF": "匯出為 PDF",
      "exportAsJSON": "匯出為 JSON",
      "addToFavorites": "加入收藏",
      "addedToFavorites": "已加入收藏",
      "linkGuestReport": "關聯訪客案件",
      "enterGuestId": "請輸入訪客標識符",
      "linkReport": "關聯案件",
      "reportLinked": "案件已成功關聯到您的帳戶",
      "errorLinkingReport": "無法關聯案件，請檢查您的訪客標識符",
      "errorFetchingReports": "取得案件資料失敗",
      "errorAddingToFavorites": "加入收藏失敗",
      "fileTooLarge": "文件過大，請選擇小於 10MB 的圖片",
      "uploadFailed": "頭像上傳失敗，請稍後再試",
      "noData": "無資料",
      "edit": "編輯",
      "editReport": "編輯案件",
      "fieldUpdated": "欄位已更新",
      "delete": "刪除",
      "cancel": "取消",
      "evidenceFiles": "證據文件",
      "noEvidenceFilesAvailable": "沒有可用的證據文件",
      "uploadNewEvidenceFiles": "上傳新的證據文件",
      "existingEvidenceFiles": "現有的證據文件",
      "addEvidenceFiles": "新增證據文件",
      "evidenceFilesUpdated": "證據文件已更新",
      "errorUpdatingEvidenceFiles": "更新證據文件時出錯",
      "reportDetails": "案件詳情",
      "reportType" : "案件是否公開",
      "public" : "在 DamenKYT 上發佈報告(公開)",
      "private" : "僅私下提交報告(不公開)",
      "noScreenshotsAvailable" : "沒有可用的截圖",




      // adminDashboard 的翻譯
      "manageUsers": "管理用戶",
      "manageArticles": "管理文章",
      "totalUsers": "總用戶數",
      "totalArticles": "總文章數",
      "accessDenied": "無權限訪問",
      "manageVideos": "管理影音",
      "createVideo": "新增影音",
      "viewApiUsage": "API用量",

      // APIUsage.js 的翻譯
      "apiUsageStatistics": "API 用量統計",
      "endpoint": "端點",
      "method": "HTTP 方法",
      "usageCount": "使用次數",
      "lastUsedAt": "最後使用時間",
      "errorFetchingApiUsage": "獲取 API 用量數據時出錯",

      // Article.js 的翻譯
      "articleManagement": "文章管理",
      "title": "標題",
      "createdAt": "創建時間",
      "actions": "操作",
      // AdminCreateArticle.js 的翻譯
      "createArticle": "新增文章",
      "content": "內容",
      "errorCreatingArticle": "創建文章時發生錯誤",
      "summary": "摘要",
      "tags": "標籤",
      "tagsPlaceholder": "請輸入標籤，以逗號分隔",
      "translation": "英文翻譯",
      "translationPlaceholder": "輸入英文翻譯內容",
      "articleCreatedSuccess": "文章已成功創建！",
      // ArticlesList.js 的翻譯
      "readMore": "閱讀更多",
      // EditArticle.js 的翻譯
      "editArticle": "編輯文章",
      "articleTitle": "文章標題",
      "articleSummary": "文章摘要",
      "articleContent": "文章內容",
      "articleTags": "文章標籤",
      "tagsPlaceholder": "請輸入標籤，以逗號分隔",
      "errorUpdatingArticle": "更新文章時發生錯誤",
      "deleteArticle": "刪除文章",

      // AdminVideos.js 的翻譯
      "videoManagement": "影音管理",
      // AdminCreateVideo.js 的翻譯
      "videoTitle": "影音標題",
      "videoSummary": "影音摘要",
      "videoTags": "影音標籤",
      "videoUrl": "影音鏈接",
      "videoCreatedSuccess": "影音已成功創建！",
      "errorCreatingVideo": "創建影音時發生錯誤",
      // VideoDetails.js 的翻譯
      "details": "詳細資訊",
      "views": "觀看次數",
      "likes": "按讚次數",
      "uploadDate": "上傳日期",
      "noTags": "無標籤",
      // EditVideo.js 的翻譯
      "editVideo": "編輯影音",


      // BlockchainAcademy.js 的翻譯
      "articles": "文章列表",
      "academyArticlesDescription": "閱讀最新的區塊鏈文章，增進知識。",
      "videos": "影音列表",
      "academyVideosDescription": "觀看區塊鏈教學影片，獲取實用資訊。",
      "resources": "資源",
      "academyResourcesDescription": "下載或瀏覽相關技術資源。",
      "downloadResource": "下載資源",
      "latestArticles": "最新文章",
      "latestVideos": "最新影音",
      "totalVideos": "總影音數",
      "removedFromFavorites" : "已從收藏中移除",
      "favoriteError" : "加入收藏時發生錯誤",
      "favorited" : "已加入收藏",
      "favorite" : "加入收藏",
      "shareOnFacebook": "分享到 Facebook",
      "shareOnTwitter": "分享到 Twitter",
      "notLoggedIn": "尚未登入",
      "redirectingToGoogleLogin": "即將轉跳 Google 登入，請稍候...",
      "articleDetail": "文章詳情",
      "videoDetails": "影音詳情",


      // Maintenance.js 的翻譯
      "maintenanceMode": "網站維護中",
      "maintenanceMessage": "我們正在進行系統更新，請稍後再試。",
      "goToHome": "返回首頁",

      // BecomePartner.js 的翻譯
      "becomePartner": "成為合作夥伴",
      "companyName": "公司名稱",
      "companyNamePlaceholder": "請輸入公司名稱",
      "contactName": "聯絡人姓名",
      "contactNamePlaceholder": "請輸入您的姓名",
      "phone": "聯絡電話",
      "phonePlaceholder": "請輸入您的聯絡電話",
      "emailPlaceholder": "請輸入您的電子郵件",
      "desiredFeatures": "未來希望的功能或服務",
      "desiredFeaturesPlaceholder": "您希望未來增加哪些功能或服務？",
      "assistance": "可以提供的協助",
      "assistancePlaceholder": "您可以提供哪些協助（例如資金、資源）？",
      "otherContactDetails": "其他聯絡資訊",
      "otherContactDetailsPlaceholder": "任何其他聯絡方式",
      "additionalMessage": "想說的話",
      "additionalMessagePlaceholder": "還有什麼話想對我們說嗎？",
      "emailRequired": "電子郵件為必填項目。",
      "formSubmittedSuccessfully": "表單提交成功！",
      "formSubmissionFailed": "表單提交失敗！",
      "submitting": "提交中...",

      // AboutUs.js 的翻譯
      "aboutUs": {
        "title": "關於我們",
        "subtitle": "了解我們的使命與願景",
        "teamTitle": "團隊介紹與產品初衷",
        "teamDescription": "Damen KYT 由一群來自台灣的加密貨幣愛好者、區塊鏈技術專家與法規顧問組成，深刻了解加密貨幣市場的潛力與挑戰，尤其在詐騙問題日益嚴重的台灣市場。我們希望透過熱情與專業，打造一個安全透明的加密貨幣交易環境，同時協助企業合規運作，並為詐騙受害者提供有效的報案工具。這不僅是一項技術任務，更是我們為台灣金融安全貢獻心力的使命。",
        "missionTitle": "我們的任務",
        "missionDescription": "加密貨幣已經開創了全新的市場，讓全球經濟變得更龐大、更公平，並且實現更深層次的整合。然而，這只是這項變革性技術潛力的開端。要讓加密貨幣充分發揮其價值，需要更高的信任與透明度，而這正是 Damen KYT 的使命所在。我們必須推動制定更清晰的法規，建立完善的審計標準，並實施強有力的合規管控措施，才能支持加密貨幣持續成長，並順利融入全球金融體系。透過我們的合規與調查工具，Damen KYT 致力於幫助實現這一願景。我們為銀行、企業及政府機構提供必要的信心與專業知識，攜手推動這個新興數位經濟的繁榮發展。",
        "featuresTitle": "我們的核心功能",
        "featureAMLTitle": "反洗錢監控",
        "featureAMLDescription": "提供先進的反洗錢（AML）技術，透過即時追蹤可疑錢包地址的資金流動，幫助企業及金融機構識別潛在風險，防範非法資金活動。平台能迅速分析大量交易數據，確保合規性並降低金融犯罪風險，讓每一筆加密貨幣交易都能在安全與透明的環境下進行。",
        "featureReportSupportTitle": "報案支援服務",
        "featureReportSupportDescription": "為協助詐騙受害者更高效地處理案件，Damen KYT 提供簡易的報案支援工具，協助用戶生成清晰明瞭的報案單，並直覺化整理報案所需的相關證據。簡化繁瑣的報案流程，讓受害者更迅速地獲得協助，提升案件處理效率。"
      },    

      // ContactUs.js 的翻譯
      "contactUs": {
        "title": "聯絡我們",
        "contactPrompt": "我們將儘速與您聯絡",
        "description": "如果您是尋求支持的受害者，請於「報告您的案例」回報案件，生成相關案例以便於報案獲得更快的幫助。無需聯繫我們。對於現有報告的查詢，請下方留下您的資訊與問題。",
        "nameLabel": "姓名",
        "enterName": "請留下您的姓名",
        "emailLabel": "電子信箱",
        "enterEmail": "請輸入您的聯絡信箱",
        "phoneLabel": "電話",
        "enterPhone": "請輸入您的電話",
        "subjectLabel": "主旨",
        "enterSubject": "請輸入您的主旨",
        "contentLabel": "內容",
        "enterMessage": "請輸入問題或需求",
        "submit": "送出資料",
        "error": {
          "submissionFailed": "提交聯絡表單失敗，請稍後再試。"
        }
      },

      // OurServices.js 的翻譯
      "services": {
        "title": "我們的服務",
        "subtitle": "我們致力於提供最專業的區塊鏈與 Web3 解決方案。",
        "blockchainFraud": {
          "title": "區塊鏈反詐騙解決方案",
          "description": "協助企業進行資金監控、風險評估及報告生成，確保資金安全。"
        },
        "web3Education": {
          "title": "Web3 教育與培訓",
          "description": "提供區塊鏈基礎課程、錢包安全操作及反詐意識提升。"
        },
        "blockchainConsulting": {
          "title": "區塊鏈技術顧問",
          "description": "提供區塊鏈金流追蹤技術相關顧問服務。"
        },
        "riskManagement": {
          "title": "數據與風險管理",
          "description": "實現資金流向監控與合規報告自動化。"
        },
        "process": {
          "title": "服務流程",
          "step1": "需求評估",
          "description1": "了解您的需求，提出專業建議。",
          "step2": "方案設計",
          "description2": "根據需求設計專屬解決方案。",
          "step3": "實施與優化",
          "description3": "專業團隊實施方案並持續優化。",
          "step4": "後續支援",
          "description4": "提供穩定的技術支援與升級服務。"
        }
      },


      // UpdateLog.js 的翻譯
      // AdminUpdateLog.js 的翻譯
      "adminUpdateLog": "更新日誌管理",
      "manageUpdateLogs": "管理更新日誌",
      "updateLogs": "更新日誌",
      "viewUpdateHistory": "查看歷史更新記錄",
      "enterVersion": "輸入版本號",
      "enterDescription": "輸入更新描述",
      "submit": "提交",
      "updateLogHistory": "更新日誌歷史",
      "version": "版本",
      "description": "描述",
      "updatedOn": "更新於",
      "noLogsFound": "目前沒有任何更新日誌。",
      "fillAllFields": "請填寫所有欄位。",
      "fetchLogsError": "取得日誌失敗。",
      "addLogError": "新增日誌失敗。",
      "logAddedSuccessfully": "日誌新增成功。",
      "updateLogError": "編輯日誌失敗。",
      "logUpdatedSuccessfully": "日誌已成功更新。",
      "edit": "編輯",
      "update": "更新",
      "lastEdited": "最後編輯",
      "never": "從未",

      // PrivacyPolicy.js 的翻譯
      privacyPolicy: {
        title: '隱私權政策',
        intro: `非常歡迎您光臨「https://kyt.damentec.com/」（以下簡稱本網站）。為了讓您能夠安心使用本網站的各項服務與資訊，我們承諾保護您的隱私，並制定以下隱私政策。請您詳閱下列內容：`,
        section1: {
          title: '一、隱私權保護政策的適用範圍',
          content: `本政策適用於本網站如何處理您在使用網站服務時提供或我們自動收集的個人識別資料。本政策不適用於其他網站或非本網站所委託管理的人員。`,
        },
        section2: {
          title: '二、個人資料的蒐集、處理及利用方式',
          items: [
            `蒐集範圍：
- 當您使用 Google 登入功能時，我們會蒐集您的基本帳戶資訊（如電子郵件地址、姓名）。
- 當您填寫表單或提供其他資料時，我們會蒐集您填寫的個人資訊，包括但不限於姓名、聯絡方式、地址。
- 若您透過鏈上錢包進行互動，我們會蒐集您的公開地址及相關記錄。`,
            `利用目的：
- 提供服務：確保您能順利使用本網站的各項功能，如帳號管理、交易記錄查詢等。
- 系統分析：透過統計數據了解用戶需求，優化使用體驗並提升服務效能。
- 合法用途：遵循法律規範，於必要時提供給相關單位。`,
            `數據保存：
- 用戶資料將僅保存於安全的伺服器中，並保存至帳戶關閉後的 6 個月，或依法律規定的最長期間。`,
          ],
        },
        section3: {
          title: '三、資料之保護',
          content: [
            `本網站採用先進的加密技術（如 HTTPS）保護數據傳輸，並使用防火牆與入侵檢測系統確保資料安全。`,
            `您的個人資料僅限經授權之人員接觸，相關處理人員均需簽署保密協議。如有違反，將依法追究責任。`,
          ],
        },
        section4: {
          title: '四、網站對外的相關連結',
          content: `本網站可能包含其他網站的連結，這些連結網站的隱私權政策不適用於本網站。建議您參考相關網站的隱私聲明。`,
        },
        section5: {
          title: '五、與第三方共用個人資料之政策',
          items: [
            `除非符合下列情況，本網站不會將您的個人資料提供予第三方：`,
            `依法要求或符合法定義務時。`,
            `為提供您必要服務或完成交易，需與合作夥伴（如支付服務商）共用。`,
            `經您明確同意。`,
          ],
        },
        section6: {
          title: '六、Cookie 與類似技術的使用',
          content: [
            `本網站使用 Cookie 及類似技術提升用戶體驗，包括功能性 Cookie、性能分析 Cookie 等。`,
            `您可通過瀏覽器設置管理或拒絕 Cookie，但可能影響部分功能的正常運作。`,
          ],
        },
        section7: {
          title: '七、隱私權保護政策之修正',
          content: `本政策將隨業務需求或法規變更進行修訂，修訂後的內容將公佈於本網站上，並以電子郵件或網站彈窗通知用戶。若您在政策更新後繼續使用本網站，即視為接受修訂內容。`,
        },
      },
      // ===================== 服務條款翻譯：繁體中文 =====================
      termsOfService: {
        title: '服務條款',
        intro: `歡迎您使用「https://kyt.damentec.com/」提供的服務。請仔細閱讀以下條款，使用本網站即視為您同意本條款。`,
        section1: {
          title: '一、服務內容',
          content: [
            `本網站提供包括但不限於帳號管理、交易記錄查詢等服務。`,
            `使用本網站功能可能需進行身份驗證（如 Google 登入）。`,
          ],
        },
        section2: {
          title: '二、用戶資格',
          content: [
            `使用者須具有完全行為能力；若為未成年人，需在法定代理人同意下使用。`,
            `若用戶違反本條款或法律規定，本網站保留中止或終止服務的權利。`,
          ],
        },
        section3: {
          title: '三、用戶註冊與帳戶安全',
          content: [
            `用戶應確保註冊資料的真實性，並妥善保管帳號密碼。`,
            `使用 Google 登入時，請確保您同意授權本網站存取必要的帳戶資訊。`,
            `若發現未經授權的帳戶使用，請立即通知本網站。用戶需對因帳戶使用而導致的所有行為承擔責任。`,
          ],
        },
        section4: {
          title: '四、鏈上錢包數據',
          content: [
            `使用鏈上錢包進行登入時，本網站將蒐集並紀錄您的公開地址。`,
            `本網站承諾僅將交易數據用於合法用途，並保護相關隱私。`,
          ],
        },
        section5: {
          title: '五、知識產權',
          content: [
            `本網站所有內容（包括文字、圖片、設計等）均受知識產權保護，未經授權不得使用。`,
            `用戶發表的內容如涉及侵權，需自行承擔相關法律責任。本網站保留刪除侵權內容的權利。`,
          ],
        },
        section6: {
          title: '六、責任限制',
          content: [
            `本網站不對因不可抗力或非本網站可控範圍內的因素導致的服務中斷或損失承擔責任。`,
            `本網站不對鏈上交易的數據準確性、完整性或合法性承擔任何責任。`,
          ],
        },
        section7: {
          title: '七、條款修改',
          content: [
            `本網站保留修改條款的權利，修改後的條款將即時生效並公佈於網站上。`,
            `修改條款後，將以電子郵件或網站彈窗通知用戶。若您繼續使用本網站，即視為接受修改內容。`,
          ],
        },
      },

      // Faqs.js 的翻譯
      "faqs": {
        "title": "常見問題",
        "searchDescription": "若您有任何疑問，請先查閱下列常見問題，或至",
        "contact": "聯絡我們",
        "searchContact": "以獲取更多協助。",
        "searchPlaceholder": "請輸入關鍵字搜尋...",
        "searchButton": "搜尋",
        "searchResults": "搜尋結果",
        "noResults": "查無相關結果",
        "categoriesTitle": "FAQ 分類",
        "privacyPolicy": {
          "title": "隱私政策"
        },
        "commonQuestions": {
          "title": "常見問題",
          "q1": {
            "question": "什麼是 DamenKYT？",
            "answer": "DamenKYT 是一款專注於區塊鏈風險管理的 Web3 反詐騙平台，提供即時錢包風險評估、跨鏈資金追蹤及報案支援。"
          },
          "q2": {
            "question": "如何查詢錢包風險？",
            "answer": "您可以在「錢包查詢」分頁中輸入錢包地址，平台會提供詳細的風險評估報告。"
          },
          "q3": {
            "question": "什麼是區塊鏈？",
            "answer": "區塊鏈（Blockchain）是一種去中心化技術，用以確保資料透明且不可竄改。"
          },
          "q4": {
            "question": "如何舉報可疑地址？",
            "answer": "您可以透過報案功能提交可疑地址及相關證據，平台將協助產生報案所需報告。或是於「錢包查詢」中查詢後，點選「這是可疑錢包」。"
          },
          "q5": {
            "question": "DamenKYT 提供哪些服務？",
            "answer": "我們提供錢包風險評估、跨鏈資金追蹤與完整的報案支援服務。"
          }
        },
        "caseReport": {
          "title": "報案說明",
          "q1": {
            "question": "如何提交報案？",
            "answer": "請點擊「報告您的案例」按鈕，填寫必要資訊後提交，您可以至「會員專區」找到您剛報告的案例，並且輸出案件報告，親自提交至您鄰近的警局。"
          },
          "q2": {
            "question": "提交報案需要哪些資料？",
            "answer": "您需要提供錢包地址、交易記錄及相關證據。"
          },
          "q3": {
            "question": "報案審核需要多久？",
            "answer": "一般來說，審核時間約為 24 至 48 小時，如果您的報案資料有誤，我們將會撤銷您的報案。"
          },
          "q4": {
            "question": "提交後可以修改報案內容嗎？",
            "answer": "提交後的報案可在「會員專區」進行修改。"
          },
          "q5": {
            "question": "誰可以查看我的報案資訊？",
            "answer": "如您有勾選「在 DamenKYT上發佈報告」，則將公開您除了個資的報案資訊，若勾選「僅私下提交報告」，則僅有經授權的內部人員可存取您的報案資料，以保護您的隱私。"
          }
        },
        "fraudSupport": {
          "title": "詐騙支援",
          "q1": {
            "question": "如何獲得詐騙支援？",
            "answer": "請透過支援頁面聯絡我們的客服團隊，我們將提供專業協助。"
          },
          "q2": {
            "question": "詐騙支援服務的工作時間是？",
            "answer": "我們的客服團隊於非國定假日的每週一至五，09:00 至 18:00 營業時間內提供支援。"
          },
          "q3": {
            "question": "平台如何防範詐騙？",
            "answer": "我們利用即時監控、風險評估與跨鏈追蹤技術來防範詐騙。"
          },
          "q4": {
            "question": "如何辨識高風險錢包？",
            "answer": "平台會根據多項指標評估錢包風險，並提供詳細報告。"
          },
          "q5": {
            "question": "是否可以匿名舉報詐騙？",
            "answer": "是的，您可以選擇匿名舉報，以保護個人隱私。"
          }
        }
      },

      // PricingPlan.js 的翻譯
      "pricingPlan": {
        "title": "平台方案",
        "subtitle": "從這裡開始您的區塊鏈調查之旅！",
        "individual": "個人",
        "team": "團隊",
        "forCollaboration": "協作用",
        "monthly": "月付",
        "semiAnnually": "半年付",
        "annually": "年付",
        "exclusiveOffer": "獨家優惠",
        "experiencePro": "體驗專業版",
        "for3Days": "3天",
        "at": "僅需",
        "getNow": "立即獲取",
        "free": "免費版",
        "basic": "基礎版",
        "pro": "專業版",
        "ultra": "旗艦版",
        "forAnyoneInterested": "適合對加密貨幣追蹤感興趣的任何人。",
        "forEverydayInvestors": "適合尋求基本DYOR功能的日常投資者和LP。",
        "forProfessional": "適合專業和機構投資者，以及鏈上分析師。",
        "forLawEnforcement": "適合執法機構和調查機構。",
        "month": "月",
        "cryptoAccepted": "接受加密貨幣",
        "subscribe": "訂閱",
        "blockchains": "區塊鏈",
        "essentialInvestigation": "基本調查功能",
        "everythingInFree": "包含免費版的所有功能，另加",
        "everythingInBasic": "包含基礎版的所有功能，另加",
        "abilityToEditSharedCharts": "能夠編輯共享圖表",
        "addMemosToCharts": "向圖表添加備忘錄",
        "expandedInterChainTracker": "擴展的跨鏈追蹤器和高級分析訪問權限",
        "solana": "Solana",
        "addressTxBatch": "地址/交易批量導入",
        "customWatermark": "自定義水印",
        "defaultWatermarkRemoval": "移除默認水印",
        "noLimitation": "無限制",
        "best": "最佳選擇",
        "subscriptionSuccess": "訂閱成功！",
        "error": {
          "subscriptionFailed": "訂閱失敗，請稍後再試。"
        },
        "currentPlan": "您當前的方案",
        "supportedBlockchains": "支持的區塊鏈",
        "chains": "14條鏈",
        "investigation": "調查",
        "basicInvestigation": "基本調查",
        "basicInvestigationDesc": "基本調查包括一般調查、實體識別、擴展收入/支出、加載更多、添加單個地址/交易。",
        "counterpartyUnavailable": "交易對手和金額範圍不可用",
        "advancedAnalysis": "高級分析",
        "interChainTracker": "跨鏈追踪器",
        "addressBatch": "地址/交易批量導入",
        "memo": "備忘錄",
        "metaSleuthWatermark": "移除MetaSleuth水印",
        "collaborationAndData": "協作與數據",
        "label": "標籤",
        "savedChart": "保存的圖表",
        "sharedLink": "共享鏈接",
        "exportingAnalysis": "導出分析數據為CSV",
        "sharedLinkEdit": "編輯共享鏈接",
        "monitor": "監控",
        "address": "地址",
        "notification": "通知",
        "restrictions": "限制",
      },

      // ApiPrice.js 的翻譯
      "ApiPrice": {
        "apis": "API 服務",
        "description": "透過我們領先業界的 API 來增強您的產品合規整合，提供合規評分和地址標籤服務。",
        "individual": "個人方案",
        "team": "團隊方案",
        "monthly": "月付",
        "semiAnnually": "半年付",
        "annually": "年付",
        "periodSemi": "6個月",
        "periodAnnual": "12個月",
        "month": "每月",
        "subscribe": "訂閱",
        "startFree": "免費開始",
        "free": "免費版",
        "basic-label": "基礎版 - 標籤",
        "basic-risk": "基礎版 - 風險評估",
        "advanced": "進階版 - 標籤 + 風險評估",
        "best": "最佳選擇",
        "labelRiskAPI": "錢包標籤 API",
        "riskAssessment": "錢包風險評估",
        "advancedQuota": "配額：每日 10,000 次請求",
        "advancedLimit": "限制：每秒 5 次請求",
        "prioritySupport": "優先技術支援",
        "quotaUpgrade": "額外請求配額",
        "advancedSupport": "進階技術支援",
        "additionalRequests": "每日額外 1,000 次請求",
        "dedicatedSupport": "專屬技術支援經理",
        "needMoreAPICalls": "需要更多 API 調用？",
        "getAddOns": "選擇加值服務！",
        "contactUs": "聯絡我們",
        "contactDescription": "無論是想要增加 API 調用配額、需要專業的技術支援，或有任何其他需求，我們都樂意為您提供協助。歡迎隨時與我們聯繫，我們將為您提供最適合的解決方案。",
        "featurefree0": "包含錢包標籤和風險評估",
        "featurefree1": "配額：每日 10 次請求",
        "featurefree2": "支援 13 條主要區塊鏈",
        "featurefree3": "基本查詢功能",
        "featurebasic-label0": "錢包標籤查詢",
        "featurebasic-label1": "配額：每日 1,000 次請求",
        "featurebasic-label2": "限制：每秒 5 次請求",
        "featurebasic-label3": "支援所有主要區塊鏈",
        "featurebasic-risk0": "錢包風險評估查詢",
        "featurebasic-risk1": "配額：每日 1,000 次請求",
        "featurebasic-risk2": "限制：每秒 5 次請求",
        "featurebasic-risk3": "支援所有主要區塊鏈",
        "advancedQuotaPrefix": "配額：",
        "advancedQuotaSuffix": "次請求",
      },

      // AdminUsers.js 的翻譯
      "role": "角色",
      "searchUser": '搜尋用戶名稱或電子郵件',
      "registrationDate": '註冊時間',
      "changeRole": '更改角色',
      "userManagement": '用戶管理',


      // DonationPage.js 的翻譯
      "supportAntiScamPlatform": "支持DamenKYT反詐騙平台",
      "donationWillHelp": "您的捐款將幫助我們持續提供免費的反詐騙服務，保護更多人遠離詐騙威脅",
      "quantity": "數量",
      "totalAmount": "總金額",
      "processing": "處理中",
      "donateNow": "立即捐款",
      "quickDonation": "快速捐款",
      "quickDonationDesc": "選擇一個捐款金額並設定數量，快速完成支持",
      "customDonation": "自定義捐款",
      "customDonationDesc": "輸入您想捐贈的具體金額",
      "enterAmount": "輸入金額",
      "use": "使用",
      "donorInformation": "捐款者資訊",
      "donorInfoDesc": "讓我們認識您，我們將發送感謝函到您的信箱（可選）",
      "donateAnonymously": "匿名捐款",
      "donorName": "姓名",
      "donorEmail": "電子郵件",
      "donorNote": "留言",
      "donorNotePlaceholder": "請留下您想對我們說的話...",
      "pleaseEnterValidAmount": "請輸入有效的金額",
      "donationProcessFailed": "捐款處理失敗",
      "donationProcessFailedTryAgain": "捐款處理失敗，請稍後再試",
      
      // DonationSuccessPage.js 的翻譯
      "donationSuccessThankYou": "捐款成功，感謝您的支持！",
      "donationSuccessMessage": "您的慷慨捐助將幫助我們持續提供免費的反詐騙服務，保護更多人遠離詐騙威脅。我們衷心感謝您為建立更安全的網路環境做出的貢獻。",
      "backToHome": "返回首頁",
      "donateAgain": "再次捐款",
      
      
      
      // DonationTransparencyPage.js 的翻譯
      "donationTransparency": "捐款透明度",
      "donationTransparency.subtitle": "我們如何利用您的捐款創造更安全的區塊鏈環境",
      "donationTransparency.introduction": "捐款透明度政策",
      "donationTransparency.introText": "在DamenKYT，我們相信對於支持者慷慨捐贈的資金使用應保持完全透明。此頁面提供了關於您捐款如何被用於改進我們的平台和擴展反詐騙計劃的詳細說明。我們承諾有效地使用每一筆捐款，為所有用戶創造更安全的區塊鏈環境。",
      "donationTransparency.howWeUse": "我們如何使用您的捐款",
      "donationTransparency.platformDevelopment": "平台開發",
      "donationTransparency.platformDevelopmentText": "分配資金用於改進我們的技術基礎設施，優化用戶界面，以及開發新功能，以更好地幫助用戶識別和預防詐騙。",
      "donationTransparency.educationInitiatives": "教育計劃",
      "donationTransparency.educationInitiativesText": "支持我們的區塊鏈學院創建全面的教育內容，幫助用戶了解區塊鏈安全知識並識別常見的詐騙手法。",
      "donationTransparency.researchPrograms": "研究項目",
      "donationTransparency.researchProgramsText": "投資於持續研究，識別新興詐騙模式，開發先進的檢測算法，以領先於詐騙者。",
      "donationTransparency.scamPreventionTools": "詐騙防範工具",
      "donationTransparency.scamPreventionToolsText": "開發和維護錢包風險評估、跨鏈資金追蹤和AI預測模型等工具，幫助用戶安全地使用區塊鏈生態系統。",
      "donationTransparency.donationReport": "捐款分配報告",
      "donationTransparency.donationReportText": "以下是捐款在我們各項計劃中分配的概況。我們定期更新此信息以確保完全透明。",
      "donationTransparency.date": "日期",
      "donationTransparency.amount": "金額",
      "donationTransparency.usage": "用途",
      "donationTransparency.totalDonation": "收到的總捐款",
      "donationTransparency.antiScamTech": "反詐騙技術開發",
      "donationTransparency.websiteDevelopment": "網站和平台優化",
      "donationTransparency.educationProgram": "區塊鏈教育計劃",
      "donationTransparency.serverMaintenance": "伺服器和基礎設施維護",
      "donationTransparency.aiRiskPrediction": "AI風險預測模型開發",
      "donationTransparency.thankYou": "感謝您的支持",
      "donationTransparency.thankYouText": "我們對您的貢獻深表感謝。您的支持使我們能夠繼續我們的使命，讓區塊鏈生態系統對每個人來說都更安全。一起，我們正在構建一個更安全的數位未來。",
      
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'zh', // 預設語言
  fallbackLng: 'en',  // 語言無法找到時使用
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
